import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW9004Model } from '../kymw9004.model';
import { KYMW9004InputModel } from '../vo/kymw9004-input.model';

/**
 * ユーザ権限情報を取得する。
 *
 * @export API通信成功時の処理
 * @class GetAuthoritySetDetailService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetAuthoritySetDetailService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9004Model;
  private vo: KYMW9004InputModel
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetAuthoritySetDetailService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        AuthoritySetId: this.vo.authoritySetId,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9000Model} model
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetAuthoritySetDetailService
   */
  execute(model: KYMW9004Model, vo: KYMW9004InputModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getAuthoritySetDetail', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetAuthoritySetDetailService
   */
  success(data: any) {
    this.model.updateAuthoritySetDetail(data);
    if ( this.successFunc !== null ) {
      this.successFunc();
    }
  }
}
